import React, { Component } from 'react';
import ArrowUp from 'react-material-icons/icons/navigation/arrow-drop-up';
import ArrowDown from 'react-material-icons/icons/navigation/arrow-drop-down'
import './SortComponent.css'

/**
 * Composant qui permet de faire un tri
 * Il affiche une ArrowUp ou ArrowDown en fonction du tri 
 * /!\ il faut lui passer l'action en paramètre
 */

class SortComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            desc: false,
        }
    }

    sort() {
        var desc = this.state.desc
        if(!this.props.isSelected) {
            desc = false
        }
        if(this.props.action) {
            this.props.action(desc);
        }
        this.setState({'desc': !desc})
    }

    render() {
        return(
            <div className={"displayLabel" + (this.props.isSelected ? " selected" : "") + (this.props.alignRight ? " alignRightLabel" : "") + (this.props.showToolTip ? " tooltip" : "")} onClick={this.sort.bind(this)}>
                {this.renderIcon()}
                <div> {this.props.text} </div>
                <div className="hooverText headerTableColumn"> {this.props.textLong}</div>
            </div>
        )
    }

    renderIcon() {
        if(this.state.desc && this.props.isSelected) {
            return (<ArrowUp />)
        } else {
            return (<ArrowDown />);
        }
    }
}

export default SortComponent;


// WEBPACK FOOTER //
// ./src/components/sort/SortComponent.js